import { useContext, useEffect } from "react";
import useGetApp from "src/hooks/useGetApp";
import useGetOrg from "src/hooks/useGetOrganization";
import { useGetAppEntitiesListRequest } from "src/services/organizations/queries/configuration";

import Context from "../context";

const useGetAppEntitiesList = () => {
	const { actions } = useContext(Context);

	const org = useGetOrg();
	const app = useGetApp();

	const { data } = useGetAppEntitiesListRequest(org.id, app?.id ?? "");

	useEffect(() => {
		if (data && data.length !== 0) actions.onSetEntities(data);
	}, [data]);
};

export default useGetAppEntitiesList;
